import Select, { SelectProps } from '@spotnana/pixel-react/dist/Select';
import { useGeoCustomization } from 'obt-common/hooks/useGeoCustomization';

import { CountryFlag } from '@spotnana/blocks/src/CountryFlag';
import { flex, margins } from '@spotnana/blocks/src/utils/styling';
import { Typography } from '@spotnana/blocks/src/Typography';
import ErrorLabel from './ErrorLabel';

interface IProps {
  label: string;
  value: string;
}

export const handleOptionLabelWithFlags = ({ label, value }: IProps): JSX.Element => (
  <div css={[flex.init, flex.align.center]}>
    {value && <CountryFlag countryCode={value} altText={label} data-testid={`${label}-${value}`} size="xsmall" />}
    <Typography variant="body2" css={[margins.xl.half]}>
      {label}
    </Typography>
  </div>
);

/**
 * This component allows to render a Select with flags.
 * Object for options should be as follows:
 * {
 *    label: <country name or a label to show>
 *    value: <ISO 2-char country code>
 * }
 */
const SelectWithFlags = (props: SelectProps): JSX.Element => {
  const { errorMessage, inputId } = props;
  const { geoCustomization } = useGeoCustomization();
  const { showFlags } = geoCustomization;

  return (
    <>
      <Select
        formatOptionLabel={showFlags ? handleOptionLabelWithFlags : undefined}
        menuContainerStyles={{ maxHeight: 180 }}
        {...props}
      />
      {errorMessage && <ErrorLabel message={errorMessage} dataTestId={`error-message-${inputId}`} />}
    </>
  );
};

export default SelectWithFlags;
